import React from "react";
import BrandBlock from "../../components/molecules/BrandBlock/BrandBlock";
import PropTypes from "prop-types";
import logo from '../../logo-website.png';
import Box from "@mui/material/Box";
import { HeaderStyles as styles } from "./header.styles";
import { useAuth0 } from "@auth0/auth0-react";
import UserProfile from "../../components/molecules/UserProfile/UserProfile";

/**
 * Page Header Element.
 * @param {string, object} pageTitle - The title of te current page.
 * @param {object} reference - The node reference to catch de header element.
 * @returns {JSX.Element}
 */
const Header = ({ pageTitle, reference}) => {
  const { user } = useAuth0();

  return (
    <header ref={reference} className={'Header'}>
      <Box className={'Header__wrapper'} sx={styles}>
        <BrandBlock logoImage={logo} logoAlt={"Insight Board"} slogan={"Insight Board | Equity data hub"}/>
        <h1 className={'Header__pageTitle'}>{pageTitle}</h1>
        <div className={'Header__profile'}>
          <UserProfile userName={user?.nickname} userPic={user?.picture}/>
        </div>
      </Box>
    </header>
  )
};

Header.propTypes = {
  pageTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
  ]).isRequired,
};

export default React.memo(Header);
